import LocationModal, {Location} from './LocationModal';

export type {Location};
export default LocationModal;
